export default function ProductParams({ data }) {
  const paramList = data?.paramList || [];

  return (
    <section className="text-[14px] text-[#69788a] mt-[16px] m-auto rounded-[8px] border border-solid border-[#ececec]">
      <h2 className="ml-[14px] mt-[10px] text-[#0b1832]">商品参数</h2>
      <div className="mt-[10px] border-t-[#ececec] border-t border-solid">
        <div className="flex min-h-[30px] border-b-[#ececec] border-b border-solid bg-[#f0f2f7]">
          <div className="px-4 py-1 w-[50%] min-h-[30px] flex items-center border-r-[#ececec] border-r border-solid">
            <span>属性</span>
          </div>
          <div className="px-4 py-1 w-[50%] min-h-[30px] flex items-center">
            <span>参数值</span>
          </div>
        </div>
        {paramList.map((item, index) => (
          <div
            className={
              index !== paramList.length - 1
                ? 'flex min-h-[30px] border-b-[#ececec] border-b border-solid'
                : 'flex min-h-[30px]'
            }
            key={index}
          >
            <div className="px-4 py-1 w-[50%] min-h-[30px] flex items-center border-r-[#ececec] border-r border-solid">
              <span className="break-all">{item.parameterName}</span>
            </div>
            <div className="px-4 py-1 w-[50%] min-h-[30px] flex items-center">
              <span className="break-all">{item.parameterValue}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
